import { combineEpics } from 'redux-observable'

import ClientEpic from './ClientEpic'
import DiagnosisEpic from './DiagnosisEpic'
import GeneralEpic from './GeneralEpic'
import TherapistEpic from './TherapistEpic'
import UserEpic from './UserEpic'

// epics
export const epics = (apis) => [
  ...ClientEpic.getAllActions(apis),
  ...UserEpic.getAllActions(apis),
  ...TherapistEpic.getAllActions(apis),
  ...GeneralEpic.getAllActions(apis),
  ...DiagnosisEpic.getAllActions(apis),
]

const rootEpic = (apis: object) => combineEpics(...epics(apis))

export default rootEpic
